var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LineChart',{attrs:{"width":_vm.width,"height":_vm.height,"chart-data":_vm.data,"options":_vm.options}})}
var staticRenderFns = []

export { render, staticRenderFns }